import { getSafe } from '../../../util/verification/verifyUndefined';
import {
  CREATE_SESSION, DESTROY_SESSION, FIND_SESSION, SIGN_LGPD_DOCUMENTS,
} from '../../actions/access';
import { withFulFilled, withPending, withRejected } from '../commons';
import { AUTHORIZERED, UNATHOURIZED } from './sessionStatus';

// initial state
const INITIAL_STATE = {
  running: false,
  error: null,
  sessionStatus: UNATHOURIZED,
};

// executer
const execute = (state = INITIAL_STATE, action) => {
  /*
    verifica se alguma requisição retornou erro 401 OU 403, caso sim adiciona
    erro na autenticação
  */
  if ((getSafe(() => action.payload.response.status) === 401)
      || (getSafe(() => action.payload.response.status) === 403)) {
    return {
      ...state,
      error: true,
      running: false,
      sessionStatus: UNATHOURIZED,
    };
  }

  switch (action.type) {
  // create
  case withPending(CREATE_SESSION):
    return {
      ...state, running: true,
    };
  case withRejected(CREATE_SESSION):
    return {
      ...state, running: false, error: action.payload,
    };
  case withFulFilled(CREATE_SESSION):
    return {
      ...state, sessionStatus: AUTHORIZERED,
    };
    // destroy
  case withPending(DESTROY_SESSION):
    return {
      ...state, running: true,
    };
  case withRejected(DESTROY_SESSION):
    return {
      ...state, running: false, error: action.payload,
    };
  case withFulFilled(DESTROY_SESSION):
    return {
      ...state, running: false, sessionStatus: UNATHOURIZED,
    };
  case withPending(FIND_SESSION):
    return {
      ...state, running: true,
    };
  case withRejected(FIND_SESSION):
    return {
      ...state, running: false, error: action.payload,
    };
  case withFulFilled(FIND_SESSION):
    return {
      ...state, sessionStatus: action.payload.data.authenticated ? AUTHORIZERED : UNATHOURIZED,
    };
  // após assinar a LGPD a sessão volta a ser válida (descarta 401/403 da pendência)
  case withFulFilled(SIGN_LGPD_DOCUMENTS):
    return {
      ...state, running: false, error: null, sessionStatus: AUTHORIZERED,
    };
  default:
    return state;
  }
};

export default execute;
